import { useRoute } from "@react-navigation/native";
import { ListTodo } from "@tamagui/lucide-icons";
import type React from "react";
import { Image, View, XStack } from "tamagui";
import { BusinessPlanHeader } from "../../business/plan/BusinessPlanHeader";
import { isRunningInApp } from "../../core/utils";
import { sendMessageToReactNative } from "../../native/webapplogic";
import { MessageType } from "../../native/webviewtypes";
import { usePlanNavigation } from "../../plans/usePlanNavigation";
import { Button } from "../Button";
import { BackToPlanHeader } from "./BackToPlanHeader";
import { BusinessProfileHeader } from "./BusinessProfileHeader";
import { ModuleHeader } from "./ModuleHeader";
import { PlanHeader } from "./PlanHeader";
import { ProfileHeader } from "./ProfileHeader";
import { UserSelectHeader } from "./UserSelectHeader";

export const Header: React.FC = () => {
  const route = useRoute();
  const routeName = route.name;

  const navigation = usePlanNavigation();

  let content = null;

  let showingBackButton = false;

  if (routeName === "Module" || routeName === "BusinessTeamModule") {
    content = <ModuleHeader />;
    showingBackButton = true;
  } else if (routeName === "Profile") {
    content = <ProfileHeader />;
    showingBackButton = true;
  } else if (
    routeName === "Home" ||
    routeName === "Create" ||
    routeName === "CreatePlanType" ||
    routeName === "BusinessDemo" ||
    routeName === "Template"
  ) {
    content = (
      <XStack
        alignItems={"center"}
        height={60}
        width={"100%"}
        backgroundColor={"$backgroundBlock"}
        onPress={() => navigation.navigate("Home")}
      >
        <Image
          objectFit="contain"
          height={26}
          width={140}
          marginStart={"$medium"}
          source={require("../../../assets/planira.png")}
          alt="Planira logo"
        />
      </XStack>
    );
  } else if (routeName === "BusinessProfile") {
    content = <BusinessProfileHeader />;
    showingBackButton = true;
  } else if (routeName.startsWith("Business")) {
    content = <BusinessPlanHeader />;
  } else if (routeName === "Plan") {
    content = <PlanHeader />;
  } else if (routeName === "PlanSettings") {
    content = <BackToPlanHeader title="Settings" />;
    showingBackButton = true;
  } else if (routeName === "Archive") {
    content = <BackToPlanHeader title="Archive" />;
    showingBackButton = true;
  } else if (routeName === "UserSelect") {
    content = <UserSelectHeader />;
  }

  if (!content) {
    return null;
  }

  const showDrawerButton = isRunningInApp() && !showingBackButton;

  // Add some white space at the top for native app UI
  return (
    <View style={{ flexDirection: "row" }}>
      <View
        position="absolute"
        top={-350}
        left={0}
        right={0}
        height={350}
        backgroundColor={"$backgroundBlock"}
      />
      {showDrawerButton && (
        <Button
          type="secondary"
          icon={ListTodo}
          onPress={() => {
            // navigation.navigate("Home");
            sendMessageToReactNative({ type: MessageType.ToggleDrawer });
          }}
        />
      )}
      <View flex={1}>{content}</View>
    </View>
  );
};
